import React, { useState, useEffect, useCallback } from 'react';
import {
  Typography,
  Table,
  Button,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Stack,
  Modal,
  Box,
  TextField,
  Divider,
  Grid,
  MenuItem,
  InputLabel,
  FormControl,
  Select,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  Autocomplete,
} from '@mui/material';

import { styled } from '@mui/material/styles';
import { Document, Page, pdfjs } from 'react-pdf';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Iconify from '../components/iconify';
// import Upload from '../components/upload';
import Scrollbar from '../components/scrollbar/Scrollbar';
import { Api, UploadFile } from '../webservices';

pdfjs.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.7.570/pdf_viewer.js.map';

function JobTracker() {
  const [open1, setOpen1] = useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const [pages, setPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [skill, setSkill] = useState('');
  const [finallst, setFinallst] = React.useState([]);
  const [tableData, setTableData] = useState([]);
  const [autocompleteValues, setAutocompleteValues] = useState([]);
  const [value, setValue] = useState({
    email: '',
    name: '',
    jobtitle: '',
    currCompany: '',
    phone: '',
    visa: '',
    tax: '',
    expectedCom: '',
    jobid: '',
    city: '',
    reloc: '',
    skill: [],
    notes: '',
  });
  const [pdffile, setPdffile] = useState(null);
  const [docfile, setDocfile] = useState();
  function onDocumentLoadSuccess({ numPages }) {
    console.log('object:', numPages, pages);
    setPages(numPages);
    setPageNumber(1);
  }

  const [valuee, setValuee] = React.useState('worksheet');

  const handleChangeAutoComplete = (event, value1) => {
    setValue({ ...value, skill: value1 });
  };

  const handleChange = (newValue) => {
    console.log(JSON.stringify(newValue));
    setValuee(newValue);

    const token = localStorage.getItem('token');
    Api(`resume/resume_by_status/${newValue}`, 'GET', '', token)
      .then((response) => {
        console.log('=========getCompany======>>>>>>>', response.data.message);
        console.log('=========getCompany======>>>>>>>', response.data.result);
        if (response.status === 200) {
          if (response.data.result.length !== 0) {
            setTableData(null);
            toast.success(response.data.message, +'!');
            setTableData(response.data.result);
          } else {
            setTableData([]);
            toast.warn('Data Not Found!');
          }
        } else {
          toast.warn(response.data.message, +'!');
        }
      })
      .catch((err) => {
        console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  useEffect(() => {
    getResume();
  }, []);

  const cities = [
    'Faridabad',
    'Gurgaon',
    'Hisar',
    'Rohtak',
    'Panipat',
    'Karnal',
    'Sonipat',
    'Yamunanagar',
    'Panchkula',
    'Bhiwani',
    'Bahadurgarh',
    'Jind',
    'Sirsa',
    'Thanesar',
  ];

  const skills = [
    'React',
    'Angular',
    'PHP',
    'node',
    'next',
    'nust',
    'Testing',
    'HTML',
    'css',
    'Vue',
    'pug',
    'scss',
    'Redux',
    'Sass',
    'MobX',
  ];

  const addskill = () => {
    if (skill !== '') {
      finallst.push(skill);
      console.log('skill', skill);
      console.log('finallst', finallst);
      setSkill('');
    }
  };

  const del = (item) => {
    // let tmp = []
    console.log('delete item', item);
    const idx = finallst.indexOf(item);
    finallst.splice(idx, 1);
    setFinallst([...finallst]);
    setSkill(null);
    console.log('list===>>>', finallst);
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '95%', sm: '70%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };
  const Item = styled(Paper)(({ theme }) => ({
    // backgroundColor: '#FF9D51',
    backgroundColor: '#f78a80',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: 'white',
  }));

  const getResume = async () => {
    const token = localStorage.getItem('token');
    Api(`resume/get_all_resumes`, 'GET', '', token)
      .then((response) => {
        console.log('=========getCompany======>>>>>>>', response.data.message);
        console.log('=========getCompany======>>>>>>>', response.data.result);
        if (response.status === 200) {
          if (response.data.result.length !== 0) {
            toast.success(response.data.message, +'!');
            setTableData(response.data.result);
          } else {
            setTableData([]);
            toast.warn('Data Not Found!');
          }
        } else {
          toast.warn(response.data.message, +'!');
        }
      })
      .catch((err) => {
        console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const pdfUpload = async () => {
    console.log('=====pdf====>>>', docfile);
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', docfile);
    formData.append('directoryName', 'resume');
    UploadFile(`resume/upload_resume`, formData, token).then((Response) => {
      console.log('=====upload Response========>', Response.data);

      if (Response.status === 200) {
        if (Response.data.code === 200) {
          toast.success(Response.data.status, +'!');
          //  console.log('=====404=gst===', Response.data.message);
          setPdffile(Response.data.filePath);
        } else {
          console.log('=====404=gst===', Response.data.message);
          toast.warn(Response.data.status, +'!');
        }
      } else {
        toast.warn(Response.data.message, +'!');
      }
    });
  };
  const addcv = async (e) => {
    e.preventDefault();
    console.log(value);
    const token = localStorage.getItem('token');
    const body = {
      name: value.name,
      email: value.email,
      phone: value.phone,
      skills: finallst,
      visa: value.visa,
      location: value.location,
      reallocate: value.reloc,
      status: value.status,
      resumeUrl: pdffile,
    };
    Api(`resume/create_resume`, 'POST', body, token)
      .then((response) => {
        console.log('===============>>>>>>>', response);
        if (response.status === 200) {
          toast.success(response.data.message, +'!');
          handleClose1();
          getResume();
          // getCompanyDetail()
          // setTableData(response.data.data)
        } else {
          toast.warn(response.data.message, +'!');
        }
      })
      .catch((err) => {
        console.log('===========', err);
      });
  };
  const funclick = () => {
    getResume();
  };
  return (
    <>
      <ToastContainer />
      <Stack flexDirection={'row'} alignItems={'flex-end'} justifyContent={'space-between'} m={1}>
        <Typography variant="h3" color={'text.secondary'}>
          My Worksheet
        </Typography>
        <Button color="custom" variant="contained" size="small" onClick={handleOpen1}>
          Add New Prospect
        </Button>
      </Stack>

      <Stack sx={{ flexDirection: 'row', gap: 2, mb: 2, cursor: 'pointer' }}>
        {/* <Stack sx={[valuee === 'started' ? { borderBottom: 4, color: '#F78A80' } : null]}>
          <Typography variant="h6" fontWeight={500} onClick={() => handleChange('started')}>
            Started
          </Typography>
        </Stack> */}
        <Stack
          sx={[
            { flexDirection: 'row' },
            valuee === 'worksheet' ? { borderBottom: 4, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            getResume();
            setValuee('worksheet');
          }}
        >
          <Iconify icon="mingcute:list-check-line" sx={{ height: 25, width: 25, mb: 2 }} />
          <Typography variant="h6" fontWeight={500} sx={{ ml: 1, mb: 2 }}>
            All
          </Typography>
        </Stack>
        <Stack
          sx={[
            { flexDirection: 'row', ml: 1 },
            valuee === 'submitted' ? { borderBottom: 4, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => handleChange('submitted')}
        >
          <Iconify icon="iconamoon:star-light" sx={{ height: 25, width: 25, mb: 2 }} />
          <Typography variant="h6" fontWeight={500} sx={{ ml: 1, mb: 2 }}>
            Submitted
          </Typography>
        </Stack>
        <Stack
          sx={[
            { flexDirection: 'row', ml: 1 },
            valuee === 'interviewing' ? { borderBottom: 4, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => handleChange('interviewing')}
        >
          <Iconify icon="ps:check-box" sx={{ height: 25, width: 25, mb: 2 }} />
          <Typography variant="h6" fontWeight={500} sx={{ ml: 1, mb: 2 }}>
            Interviewing
          </Typography>
        </Stack>
        <Stack
          sx={[
            { flexDirection: 'row', ml: 1 },
            valuee === 'placement' ? { borderBottom: 4, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => handleChange('placement')}
        >
          <Iconify icon="lucide:dollar-sign" sx={{ height: 25, width: 25, mb: 2 }} />
          <Typography variant="h6" fontWeight={500} sx={{ ml: 1, mb: 2 }}>
            Placement
          </Typography>
        </Stack>
        <Stack
          sx={[
            { flexDirection: 'row', ml: 1 },
            valuee === 'placement' ? { borderBottom: 4, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => handleChange('placement')}
        >
          <Iconify icon="bx:error" sx={{ height: 25, width: 25, mb: 2 }} />
          <Typography variant="h6" fontWeight={500} sx={{ ml: 1, mb: 2 }}>
            Backout
          </Typography>
        </Stack>
      </Stack>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ justifyContent: 'flex-start' }}>
              <TableCell>Date</TableCell>
              <TableCell>Detail</TableCell>
              <TableCell>Contact Details</TableCell>
              <TableCell>Skills</TableCell>
              <TableCell>Visa & Terms</TableCell>
              <TableCell>Client & Status</TableCell>
              <TableCell>Notes</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((item) => (
              <ResumeRow key={item._id} row={item} fun={funclick} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Modal open={open1} onClose={handleClose1} style={{ borderRadius: 10 }}>
        <Box sx={style}>
          <Typography variant="h4" color={'#3C6BA5'} textAlign={'center'}>
            New Candidate
          </Typography>
          <Scrollbar sx={{ maxHeight: 600, Scrollbar: 'thin' }}>
            <Divider />
            <Grid display={'grid'} gridTemplateColumns={{ md: 'repeat(2, 1fr)', sm: 'repeat(1, 1fr)' }} py={2} gap={4}>
              <Stack gap={2}>
                <TextField
                  id="outlined-basic"
                  label="Email"
                  placeholder="Email"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.email}
                  onChange={(e) => setValue({ ...value, email: e.target.value })}
                />

                <TextField
                  id="outlined-basic"
                  label="Full Name"
                  placeholder="Full Name"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.name}
                  onChange={(e) => setValue({ ...value, name: e.target.value })}
                />

                <TextField
                  id="outlined-basic"
                  label="Job title"
                  placeholder="Job title"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.jobtitle}
                  onChange={(e) => setValue({ ...value, jobtitle: e.target.value })}
                />
                <TextField
                  id="outlined-basic"
                  label="Current Company"
                  placeholder="Current Company"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.currCompany}
                  onChange={(e) => setValue({ ...value, currCompany: e.target.value })}
                />

                <TextField
                  id="outlined-basic"
                  label="Phone"
                  placeholder="Phone"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.phone}
                  inputProps={{ type: 'numeric', pattern: '[0-9]*', maxLength: 10, minLength: 10 }}
                  onChange={(e) => setValue({ ...value, phone: e.target.value })}
                />

                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Visa</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    InputLabelProps={{ shrink: true }}
                    label="Visa"
                    placeholder="Visa"
                    value={value.visa}
                    onChange={(e) => setValue({ ...value, visa: e.target.value })}
                  >
                    <MenuItem value={'USC'}>USC</MenuItem>
                    <MenuItem value={'GC'}>GC</MenuItem>
                    <MenuItem value={'GCEAD'}>GCEAD</MenuItem>
                    <MenuItem value={'TN'}>TN</MenuItem>
                    <MenuItem value={'H1B'}>H1B</MenuItem>
                    <MenuItem value={'H1b I 140 '}>H1b I 140 </MenuItem>
                    <MenuItem value={'H4 EAD'}>H4 EAD</MenuItem>
                    <MenuItem value={'OPT EAD'}>OPT EAD</MenuItem>
                    <MenuItem value={'CPT EAD'}>CPT EAD</MenuItem>
                    <MenuItem value={'E2 Visa'}>E2 Visa</MenuItem>
                    <MenuItem value={'B 1 Visa'}>B 1 Visa</MenuItem>
                    <MenuItem value={'Canadian citizen'}>Canadian Citizen</MenuItem>
                    <MenuItem value={'Open work permit'}>Open work Permit</MenuItem>
                  </Select>
                </FormControl>

                <FormControl>
                  <FormLabel id="demo-radio-buttons-group-label">Tax Term</FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="c2c"
                    name="radio-buttons-group"
                    value={value.tax}
                    onChange={(e) => setValue({ ...value, tax: e.target.value })}
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      ml: 1,
                    }}
                  >
                    <FormControlLabel value="c2c" control={<Radio />} label="C2C" />
                    <FormControlLabel value="w2" control={<Radio />} label="W2" />
                    <FormControlLabel value="1099" control={<Radio />} label="1099" />
                    <FormControlLabel value="T4" control={<Radio />} label="T4" />
                    <FormControlLabel value="INC" control={<Radio />} label="INC" />
                    <FormControlLabel value="na" control={<Radio />} label="NA" />
                  </RadioGroup>
                </FormControl>

                <TextField
                  id="outlined-basic"
                  label="Expected Compensation( In Dollars )*"
                  placeholder="Expected Compensation"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.expectedCom}
                  onChange={(e) => setValue({ ...value, expectedCom: e.target.value })}
                />

                <>
                  {/* <Stack>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Status</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Status"
                      placeholder="Status"
                      SelectProps={{ native: false, sx: { textTransform: 'capitalize' } }}
                      value={value.status}
                      onChange={(e) => setValue({ ...value, status: e.target.value })}
                    >
                      <MenuItem value={'submitted'}>Submitted</MenuItem>
                      <MenuItem value={'interviewing'}>Interviewing</MenuItem>
                      <MenuItem value={'placement'}>Placement</MenuItem>
                    </Select>
                  </FormControl>
                  <Stack sx={{ flexDirection: 'row', mt: 2, width: '100%' }}>
                    <Stack sx={{ width: '81%' }}>
                      <input
                        type="file"
                        accept="application/pdf"
                        style={{ fontSize: 18 }}
                        onChange={(e) => setDocfile(e.target.files[0])}
                      />
                    </Stack>
                    {docfile ? (
                      <Stack sx={{ mt: 0.5 }}>
                        <Button color="custom" variant="outlined" onClick={() => pdfUpload()}>
                          Upload File
                        </Button>
                      </Stack>
                    ) : null}
                  </Stack>
                </Stack>
                <Box>
                  <Stack sx={{ flexDirection: 'row', gap: 2, width: '100%' }}>
                    <Stack sx={{ width: '95%' }}>
                      <TextField
                        id="outlined-basic"
                        label="Skill"
                        placeholder="Skill"
                        variant="outlined"
                        value={skill}
                        onChange={(e) => setSkill(e.target.value)}
                      />
                    </Stack>
                    <Button color="custom" variant="outlined" onClick={() => addskill()}>
                      Add
                    </Button>
                  </Stack>
                  {finallst.length ? (
                    <Box sx={{ marginTop: 2 }}>
                      <Grid container spacing={2}>
                        {finallst.map((item) => {
                          return (
                            <Grid item>
                              <Item>
                                {item}
                                <Iconify
                                  icon="basil:cross-outline"
                                  sx={{ color: 'white', width: 20, height: 20 }}
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => del(item)}
                                />
                              </Item>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Box>
                  ) : null}
                </Box> */}
                </>
              </Stack>
              <Stack gap={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Job Id search option</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Job Id search option"
                    placeholder="Job Id search option"
                    InputLabelProps={{ shrink: true }}
                    value={value.jobid}
                    onChange={(e) => setValue({ ...value, jobid: e.target.value })}
                  >
                    <MenuItem value={'yes'}>Yes</MenuItem>
                    <MenuItem value={'no'}>No</MenuItem>
                  </Select>
                </FormControl>
                <Autocomplete
                  fullWidth
                  disablePortal
                  id="combo-box-demo"
                  options={cities}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="City / Zip code"
                      InputLabelProps={{ shrink: true }}
                      label="City / Zip code*"
                      value={value.city}
                      onChange={(e) => setValue({ ...value, city: e.target.value })}
                    />
                  )}
                />
                <FormControl fullWidth>
                  <FormLabel id="demo-radio-buttons-group-label">Can Reallocate</FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="yes "
                    name="radio-buttons-group"
                    value={value.reloc}
                    onChange={(e) => setValue({ ...value, reloc: e.target.value })}
                    sx={{ display: 'flex', flexDirection: 'row', ml: 1 }}
                  >
                    <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                    <FormControlLabel value="no" control={<Radio />} label="No" />
                  </RadioGroup>
                </FormControl>
                <Stack sx={{ position: 'relative' }}>
                  <Autocomplete
                    fullWidth
                    multiple
                    id="tags-standard"
                    options={skills}
                    value={value.skill}
                    onChange={handleChangeAutoComplete}
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Skills" InputLabelProps={{ shrink: true }} label="Skills" />
                    )}
                  />
                </Stack>
                <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' } }}>
                  <Stack
                    sx={{
                      flexDirection: { xs: 'column', sm: 'row' },
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Typography variant="subtitle1">Upload Resume*</Typography>
                    <input type="file" accept="application/pdf" onChange={(e) => setDocfile(e.target.files[0])} />
                  </Stack>
                  {docfile ? (
                    <Stack sx={{ mt: 0.5 }}>
                      <Button color="custom" variant="outlined">
                        <a href={docfile} target="_jobportal">
                          View File
                        </a>
                      </Button>
                      <Button color="custom" variant="outlined" onClick={() => pdfUpload()}>
                        Upload File
                      </Button>
                    </Stack>
                  ) : null}
                </Stack>
                <TextField
                  id="outlined-multiline-static"
                  label="Note... (Max 2000 char)"
                  placeholder="Note..."
                  multiline
                  rows={5}
                  value={value.notes}
                  onChange={(e) => setValue({ ...value, notes: e.target.value })}
                />
                <Stack flexDirection={'row'} gap={1} mt={1}>
                  <Button color="custom" variant="contained" onClick={(e) => addcv(e)}>
                    Add CV
                  </Button>
                </Stack>
              </Stack>
            </Grid>
          </Scrollbar>
        </Box>
      </Modal>
    </>
  );
}

export default JobTracker;

function ResumeRow({ row, fun }) {
  const [status, setStatus] = useState('Pending');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openpdf, setOpenpdf] = useState(false);

  const handleOpenpdf = () => setOpenpdf(true);
  const Closepdf = () => setOpenpdf(false);
  const [pdffile, setPdffile] = useState(null);
  const [docfile, setDocfile] = useState();
  const [commentt, setCommentt] = useState('');

  const [value, setValue] = useState({
    name: row.name,
    email: row.email,
    phone: row.phone,
    visa: row.visa,
    location: row.location,
    reloc: row.reallocate,
    status: row.status,
  });
  const [skill, setSkill] = useState('');
  const [finallst, setFinallst] = useState(row.skills);
  const [cmntarr, setCmntarr] = useState([]);
  console.log(row.Date);
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '900px',
    height: '90%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    flexDirection: 'row',
    display: 'flex',
    gap: 2,
  };
  const style2 = {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  };
  const style3 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 3,
  };
  const Item = styled(Paper)(({ theme }) => ({
    // backgroundColor: '#FF9D51',
    backgroundColor: '#f78a80',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: 'white',
  }));

  function addskill() {
    if (skill !== '') {
      console.log('add', finallst);
      finallst.push(skill);
      setSkill('');
    }
  }

  function del(item) {
    // setSkill("");
    const idx = finallst.indexOf(item);
    finallst.splice(idx, 1);
    setFinallst([...finallst]);
    console.log('delete', finallst);
    setSkill(null);
  }

  const pdfUpload = async () => {
    console.log('=====pdf====>>>', docfile);
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', docfile);
    formData.append('directoryName', 'resume');
    UploadFile(`resume/upload_resume`, formData, token).then((Response) => {
      console.log('=====upload Response========>', Response.data);

      if (Response.status === 200) {
        if (Response.data.code === 200) {
          toast.success(Response.data.status, +'!');
          //  console.log('=====404=gst===', Response.data.message);
          setPdffile(Response.data.filePath);
        } else {
          console.log('=====404=gst===', Response.data.message);
          toast.warn(Response.data.status, +'!');
        }
      } else {
        toast.warn(Response.data.message, +'!');
      }
    });
  };
  const editResume = async () => {
    const id = row._id;
    const token = localStorage.getItem('token');

    const body = {
      name: value.name,
      email: value.email,
      phone: value.phone,
      skills: finallst,
      visa: value.visa,
      location: value.location,
      reallocate: value.reallocate,
      status: value.status,
      resumeUrl: pdffile,
    };
    Api(`resume/update_resume/${id}`, 'POST', body, token)
      .then((Response) => {
        console.log('======getUser==response=====>', Response);
        if (Response.status === 200) {
          handleClose();

          toast.success(Response.data.message);
          fun();
          console.log('======getUser===data.data pdata====>', Response);
        } else {
          console.log('======getUser=======>', +Response);
          toast.warn(Response.data.message);
          // enqueueSnackbar(Response.data.message);
        }
      })
      .catch((err) => {
        toast.error(err, +'!');
        console.log('===========', err);
      });
  };

  const getComment = async (cvid) => {
    const token = localStorage.getItem('token');
    handleOpenpdf();
    Api(`resume/get_comments/${cvid}`, 'GET', '', token)
      .then((response) => {
        console.log('get comment', JSON.stringify(response.data.result.comments));
        setCmntarr(response.data.result.comments);
      })
      .catch((err) => {
        toast.error(err, +'!');
        console.log('===========', err);
      });
  };
  const addComment = async (cvid) => {
    const token = localStorage.getItem('token');
    // const id = localStorage.getItem('userid');
    const namee = localStorage.getItem('name');
    const body = {
      resumeId: cvid,
      name: namee,
      comment: commentt,
    };
    if (commentt !== '') {
      Api(`resume/add_comment`, 'POST', body, token)
        .then((response) => {
          // console.log('comment', response);
          if (response.status === 200) {
            if (response.data.code === 200) {
              setCommentt('');
              toast.success(response.data.message);
              getComment(cvid);
            } else {
              toast.warn(response.data.message);
            }
          }
        })
        .catch((err) => {
          toast.error(err, +'!');
          console.log('===========', err);
        });
    }
  };
  return (
    <>
      <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} hover>
        <TableCell sx={{ pl: 2 }}>
          <Typography sx={{ mb: 0.5 }}>Since 6 months</Typography>
          <Typography sx={{ mb: 0.5 }} color={'text.textG'}>
            Updated 20 days ago
          </Typography>
          <Typography sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer', mb: 0.5 }}>Edit</Typography>
        </TableCell>
        <TableCell onClick={() => getComment(row._id)} sx={{ pl: 2 }}>
          <Typography sx={{ mb: 0.5 }} variant="h6" color={'text.secondary'}>
            {row.name}
          </Typography>
          <Typography sx={{ mb: 0.5 }} color={'text.textG'}>
            Sr.Backend Developer
          </Typography>
          <Typography sx={{ mb: 0.5 }} color={'text.textG'}>
            TCS
          </Typography>
        </TableCell>
        <TableCell sx={{ pl: 2 }}>
          <Typography sx={{ mb: 0.5 }}>{row.phone}</Typography>
          <Typography sx={{ mb: 0.5 }}>{row.email}</Typography>
          <Typography sx={{ mb: 0.5 }} color={'text.textG'}>
            {row.location}
          </Typography>
        </TableCell>
        <TableCell sx={{ pl: 2 }}>
          {/* {row.skills.map((item) => {
            return (
              <span style={{ flexDirection: 'column', display: 'flex' }}>
                {item}
                {','}
              </span>
            );
          })} */}
          <Typography sx={{ mb: 0.5 }} color={'text.textG'}>
            {row.skills[0]},{row.skills[1]},
          </Typography>
          <Typography sx={{ mb: 0.5 }} color={'text.textG'}>
            {row.skills[2]}
          </Typography>
          <Typography sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer', mb: 0.5 }}>
            view all
          </Typography>
        </TableCell>
        <TableCell sx={{ pl: 2 }}>
          <Typography sx={{ mb: 0.5 }}>{row.visa}</Typography>
          <Typography sx={{ mb: 0.5 }} color={'text.textG'}>
            $100K
          </Typography>
          <Typography sx={{ mb: 0.5 }} color={'text.textG'}>
            W2
          </Typography>
        </TableCell>
        <TableCell sx={{ pl: 2 }}>
          <Typography sx={{ mb: 0.5 }}>{row.status}</Typography>
          <Typography sx={{ mb: 0.5 }} color={'text.textG'}>
            -
          </Typography>
          <Typography sx={{ mb: 0.5 }} color={'text.textG'}>
            Iron man
          </Typography>
        </TableCell>
        <TableCell sx={{ pl: 2 }}>
          <Typography sx={{ mb: 0.5 }} color={'text.textG'}>
            hello everyone my name is ghuchdu
          </Typography>
          <Typography sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer', mb: 0.5 }}>more</Typography>
        </TableCell>
        <TableCell sx={{ pl: 2 }}>
          {/* <Button color="custom" type="submit" variant="contained" size="small" onClick={() => handleOpen()}>
            Edit
          </Button> */}
          <Stack sx={{ flexDirection: 'row', cursor: 'pointer', mb: 0.5 }} color={'text.secondary'}>
            <Iconify icon="ic:baseline-email" sx={{ height: 25, width: 25 }} />
            <Typography variant="subtitle1" sx={{ ml: 0.5 }}>
              Email
            </Typography>
          </Stack>
          <Stack sx={{ flexDirection: 'row', cursor: 'pointer', mb: 0.5 }} color={'text.secondary'}>
            <Iconify icon="bx:support" sx={{ height: 25, width: 25 }} />
            <Typography variant="subtitle1" sx={{ ml: 0.5 }}>
              Contact
            </Typography>
          </Stack>
          <Stack sx={{ flexDirection: 'row', cursor: 'pointer', mb: 0.5 }} color={'text.secondary'}>
            <Iconify icon="icon-park-solid:check-one" sx={{ height: 25, width: 25 }} />
            <Typography variant="subtitle1" sx={{ ml: 0.5 }}>
              Submit
            </Typography>
          </Stack>
        </TableCell>
      </TableRow>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style3}>
          <Scrollbar>
            <Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(2, 1fr)', xs: 'repeat(1, 1fr)' }} py={1} gap={2}>
              <TextField
                id="outlined-basic"
                label="Full Name"
                placeholder="Full Name"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={value.name}
                onChange={(e) => setValue({ ...value, name: e.target.value })}
              />

              <TextField
                id="outlined-basic"
                label="Email"
                placeholder="Email"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={value.email}
                onChange={(e) => setValue({ ...value, email: e.target.value })}
              />

              <TextField
                id="outlined-basic"
                label="Phone"
                placeholder="Phone"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={value.phone}
                inputProps={{ type: 'numeric', pattern: '[0-9]*', maxLength: 10, minLength: 10 }}
                onChange={(e) => setValue({ ...value, phone: e.target.value })}
              />
              {/* 
              <TextField
                id="outlined-basic"
                label="Visa"
                placeholder="Visa"
                variant="outlined"
                
                value={value.visa}
                onChange={(e) => setValue({ ...value, visa: e.target.value })}
              /> */}
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Visa</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Visa"
                  InputLabelProps={{ shrink: true }}
                  placeholder="Visa"
                  value={value.visa}
                  onChange={(e) => setValue({ ...value, visa: e.target.value })}
                >
                  <MenuItem value={'USC'}>USC</MenuItem>
                  <MenuItem value={'GC'}>GC</MenuItem>
                  <MenuItem value={'GCEAD'}>GCEAD</MenuItem>
                  <MenuItem value={'TN'}>TN</MenuItem>
                  <MenuItem value={'H1B'}>H1B</MenuItem>
                  <MenuItem value={'H1b I 140 '}>H1b I 140 </MenuItem>
                  <MenuItem value={'H4 EAD'}>H4 EAD</MenuItem>
                  <MenuItem value={'OPT EAD'}>OPT EAD</MenuItem>
                  <MenuItem value={'CPT EAD'}>CPT EAD</MenuItem>
                  <MenuItem value={'E2 Visa'}>E2 Visa</MenuItem>
                  <MenuItem value={'B 1 Visa'}>B 1 Visa</MenuItem>
                  <MenuItem value={'Canadian citizen'}>Canadian Citizen</MenuItem>
                  <MenuItem value={'Open work permit'}>Open work Permit</MenuItem>
                </Select>
              </FormControl>
              <TextField
                id="outlined-basic"
                label="Location"
                placeholder="Location"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={value.location}
                onChange={(e) => setValue({ ...value, location: e.target.value })}
              />
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Relocate</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Relocation"
                  placeholder="Relocation"
                  value={value.reloc}
                  onChange={(e) => setValue({ ...value, reloc: e.target.value })}
                >
                  <MenuItem value={'yes'}>Yes</MenuItem>
                  <MenuItem value={'no'}>No</MenuItem>
                </Select>
              </FormControl>
              <Stack>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Status</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Status"
                    placeholder="Status"
                    SelectProps={{ native: false, sx: { textTransform: 'capitalize' } }}
                    value={value.status}
                    onChange={(e) => setValue({ ...value, status: e.target.value })}
                  >
                    <MenuItem value={'submitted'}>Submitted</MenuItem>
                    <MenuItem value={'interviewing'}>Interviewing</MenuItem>
                    <MenuItem value={'placement'}>Placement</MenuItem>
                  </Select>
                </FormControl>
                <Stack sx={{ mt: 2, flexDirection: 'row', width: '100%' }}>
                  <Stack sx={{ width: '83%' }}>
                    <input
                      type="file"
                      accept="application/pdf"
                      style={{ fontSize: 18 }}
                      onChange={(e) => setDocfile(e.target.files[0])}
                    />
                  </Stack>
                  {/* <Upload file={docfile} onDrop={handleDropSingleFile}  /> */}

                  {docfile ? (
                    <Stack sx={{ mt: 0.5 }}>
                      <Button color="custom" variant="outlined" onClick={() => pdfUpload()}>
                        Upload File
                      </Button>
                    </Stack>
                  ) : null}
                </Stack>
              </Stack>
              <Stack>
                <Box>
                  <Stack sx={{ flexDirection: 'row', gap: 2, width: '100%' }}>
                    <Stack sx={{ width: '95%' }}>
                      <TextField
                        id="outlined-basic"
                        label="Skill"
                        placeholder="Skill"
                        variant="outlined"
                        value={skill}
                        onChange={(e) => setSkill(e.target.value)}
                      />
                    </Stack>
                    {/* <Iconify
                    icon="icon-park-outline:add"
                    sx={{ color: 'text.secondary', width: 55, height: 55 }}
                    style={{ cursor: 'pointer' }}
                    onClick={() => addskill()}
                  /> */}
                    <Button color="custom" variant="outlined" onClick={() => addskill()}>
                      Add
                    </Button>
                  </Stack>
                </Box>
                <Box sx={{ marginTop: 2 }}>
                  <Grid container spacing={2}>
                    {finallst.map((item) => {
                      return (
                        <Grid item>
                          <Item>
                            {item}
                            <Iconify
                              icon="basil:cross-outline"
                              sx={{ color: 'white', width: 20, height: 20 }}
                              style={{ cursor: 'pointer' }}
                              onClick={() => del(item)}
                            />
                          </Item>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Box>
              </Stack>
            </Grid>
          </Scrollbar>
          <Stack flexDirection={'row'} gap={1} mt={2}>
            <Button color="custom" variant="contained" onClick={(e) => editResume(e)}>
              save
            </Button>
          </Stack>
        </Box>
      </Modal>
      <Modal
        open={openpdf}
        onClose={Closepdf}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Grid sx={style}>
          <Box sx={{ width: '60%', height: '85%', mx: 3, my: 3 }}>
            <Scrollbar sx={{}}>
              <iframe title="resume" src={row.resumeUrl} width="100%" height="350" />
              <Divider />
              {cmntarr.length
                ? cmntarr.map((item) => {
                    return (
                      <Stack sx={{ border: '1px solid #dadada', borderRadius: '5px', p: 1, mt: 1, mb: 1 }}>
                        <Typography id="modal-modal-description" variant="body1" sx={{}}>
                          {item.comment}
                        </Typography>
                        <Typography variant="caption">{item.createdAT}</Typography>
                        <Typography variant="caption">
                          by <span>{item.name}</span>
                        </Typography>
                      </Stack>
                    );
                  })
                : null}
            </Scrollbar>
            <Stack flexDirection={'row'} gap={1}>
              <TextField
                size="small"
                placeholder="Comment..."
                sx={{ width: '100%' }}
                value={commentt}
                onChange={(e) => setCommentt(e.target.value)}
              />
              <Button color="custom" variant="contained" onClick={() => addComment(row._id)}>
                Post
              </Button>
            </Stack>
          </Box>
          <Box sx={{ my: 3, width: '330px' }}>
            <Stack sx={style2}>
              <Typography>Name:</Typography>
              <Typography sx={{ ml: 2 }}>{row.name}</Typography>
            </Stack>
            <Stack sx={style2}>
              <Typography>Email:</Typography>
              <Typography sx={{ ml: 2 }}>{row.email}</Typography>
            </Stack>
            <Stack sx={style2}>
              <Typography>Phone:</Typography>
              <Typography sx={{ ml: 2 }}>{row.phone}</Typography>
            </Stack>
            <Stack sx={style2}>
              <Typography>Skill:</Typography>
              <Typography sx={{ ml: 2 }}>
                {row.skills.map((item) => {
                  return (
                    <span style={{ flexDirection: 'row', flex: 'display' }}>
                      {item}
                      {','}
                    </span>
                  );
                })}
              </Typography>
            </Stack>
            <Stack sx={style2}>
              <Typography>Visa:</Typography>
              <Typography sx={{ ml: 2 }}>{row.visa}</Typography>
            </Stack>
            {/* <Stack sx={style2}>
              <Typography>Taxterm:</Typography>
              <Typography sx={{ ml: 2 }}>{row.visa}</Typography>
            </Stack> */}
            <Stack sx={style2}>
              <Typography>Location:</Typography>
              <Typography sx={{ ml: 2 }}>{row.location}</Typography>
            </Stack>
            <Stack sx={style2}>
              <Typography>Open to Relocate:</Typography>
              <Typography sx={{ ml: 2 }}>{row.reallocate}</Typography>
            </Stack>
            {/* <Stack sx={style2}>
              <Typography>Salary:</Typography>
              <Typography sx={{ ml: 2 }}>{row.visa}</Typography>
            </Stack> */}
            {/* <Stack sx={style2}>
              <Typography>Note:</Typography>
              <Typography sx={{ ml: 2 }}>{row.visa}</Typography>
            </Stack> */}
            <Stack sx={style2}>
              <Typography>Status:</Typography>
              <Typography sx={{ ml: 2 }}>{row.visa}</Typography>
            </Stack>
            {/* <Stack sx={style2}>
              <Typography>Presented to:</Typography>
              <Typography sx={{ ml: 2 }}>{row.visa}</Typography>
            </Stack>
            <Stack sx={style2}>
              <Typography>Pipeline of Candidate:</Typography>
              <Typography sx={{ ml: 2 }}>{row.visa}</Typography>
            </Stack> */}
          </Box>
        </Grid>
      </Modal>
    </>
  );
}
